import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getGroupObjects,
	getGroupObjectsEndpoint,
	type QueryError,
	type GetGroupObjectsResult,
	type GetGroupObjectsRequestOptions,
} from '../getGroupObjects';
export * from '../getGroupObjects';

export type GetGroupObjectsQueryParams = GetGroupObjectsRequestOptions;
export type GetGroupObjectsQueryKey = [string, GetGroupObjectsQueryParams];

export type GetGroupObjectsQueryOptions = Omit<
	UseQueryOptions<
		GetGroupObjectsResult,
		QueryError,
		GetGroupObjectsResult,
		GetGroupObjectsQueryKey
	>,
	'queryKey' | 'queryFn'
> & {
	queryFn?: typeof getGroupObjects;
};

export const GetGroupObjectsReactQueryKey = getGroupObjectsEndpoint;

/**
 * react-query wrapper for `getGroupObjects`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetGroupObjects = (
	queryKeyParams: GetGroupObjectsQueryParams,
	{queryFn = getGroupObjects, ...options}: GetGroupObjectsQueryOptions = {},
) =>
	useQuery<
		GetGroupObjectsResult,
		QueryError,
		GetGroupObjectsResult,
		GetGroupObjectsQueryKey
	>({
		queryKey: [getGroupObjectsEndpoint, queryKeyParams],
		queryFn: ({queryKey, signal}) => queryFn({...queryKey[1]}, signal),
		...options,
	});

export default useReactQueryGetGroupObjects;
